<template>
    <div class="background">
        <div style="background-color: #FFFFFF; width: 100%; height: 90%; margin: 10px 0 10px 10px">
            <el-row style="height: 6%;">
                <div class="text">锁场</div>
            </el-row>
            <el-row style="height: 40%;">
                <div>
                    <label class="text1">锁定预约时间</label>
                    <label class="text2">选择时间段</label>
                </div>
                <div class="block" style="margin: 20px 0 20px 20px">
                    <el-date-picker
                        v-model="value1"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                    <el-time-select
                        v-model="value"
                        :picker-options="{
    start: '08:30',
    step: '00:15',
    end: '18:30'
  }"
                        placeholder="选择时间">
                    </el-time-select>
                    至
                    <el-date-picker
                        v-model="value1"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                    <el-time-select
                        v-model="value"
                        :picker-options="{
    start: '08:30',
    step: '00:15',
    end: '18:30'
  }"
                        placeholder="选择时间">
                    </el-time-select>
                </div>
                <label class="text1">锁定预约时间</label>
                <label class="text2">选择特定场次</label>
                <div class="block" style="margin: 20px 0 0 20px">
                    <el-date-picker
                        v-model="value1"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                    <el-time-select
                        v-model="value"
                        :picker-options="{
    start: '08:30',
    step: '00:15',
    end: '18:30'
  }"
                        placeholder="选择时间">
                    </el-time-select>
                    <el-radio v-model="radio" label="1">锁定全部时间</el-radio>
                </div>
            </el-row>
            <el-row style="height: 6%;">
                <div class="text">设置</div>
            </el-row>
            <el-row style="height: 15%;">
                <div>
                    <label class="text1">*每场最大预约人数</label>
                    <label class="text2">应用全场</label>
                </div>
                <div>
                    <el-col :span="6" style="margin: 20px 0 0 20px">
                        <el-input v-model="input" placeholder="请输入内容"></el-input>
                    </el-col>
                </div>


            </el-row>
            <el-row style="height: 20%; text-align: center; justify-items: center">
                <el-button>默认按钮</el-button>
                <el-button type="primary">主要按钮</el-button>

            </el-row>
        </div>
    </div>

</template>

<script>
import headTop from '../components/headTop'

export default {
    name: "reservationSetting",
    components: {
        headTop,
    },
    data() {
        return {
            value1: '',
            value: '',
            input: '',
            radio: ''
        }
    }
}
</script>

<style scoped>
.text {
    width: 132px;
    height: 31px;
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 600;
    line-height: 30.8px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0 0 8px 20px;
    color: #0D062D;

}

.text1 {
    width: 120px;
    height: 28px;
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #8A96B1;
    margin: 20px 0 20px 20px;
}

.text2 {
    width: 90px;
    height: 25px;
    top: 237px;
    left: 440px;
    gap: 0px;
    opacity: 0px;
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 400;
    line-height: 25.2px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 20px 0 20px 20px;
    color: #0D062D;

}

.background {
    background-color: #F4F5FA;
}
/*.el-input__icon el-icon-date{*/
/*    border: 1.5px solid #5C16F2*/
/*}*/


</style>
